<template>
  <v-sheet class="d-flex" id="personal-data-sheet">
    <v-card>
      <v-card-title>
        <h4>Données personnelles</h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-tile>
          <v-list-tile-content>
            <b>Nom, prénom</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_name }}
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_fsname }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Formation, lieu</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.job_full_value }},
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.location_site }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Maturité</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            <span
              v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_maturity"
            >&#10004;</span>
            <span v-else>&#10008;</span>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Adresse</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_address_street }},
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_address_npa }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Email</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_mail }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Téléphones (privé, domicile)</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_personal_phone }},
            {{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_home_phone }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Date naissance, majeur</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_birthdate }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Majeur</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            <span
              v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_has_majority"
            >&#10004;</span>
            <span v-else>&#10008;</span>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Numéro AVS</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_avs }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Nationalité</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_nationality }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Origine</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_origin }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Langues</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            <div>
              <img
                src="@/assets/french_logo.png"
                alt="logo_french"
                width="20"
                v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_speaks_french"
              >
              <img
                src="@/assets/german_logo.png"
                alt="logo_german"
                width="20"
                v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_speaks_german"
              >
              <img
                src="@/assets/english_logo.png"
                alt="logo_english"
                width="20"
                v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_speaks_english"
              >
              <img
                src="@/assets/others_logo.png"
                alt="logo_others"
                width="20"
                v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_speaks_other"
              >
            </div>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Fin de scolarité</b>
          </v-list-tile-content>
          <v-list-tile-content
            class="align-end"
          >{{ $store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_scolarity_end }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Déjà candidat ? (Année)</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">
            <span
              v-if="$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_already_applicant"
            >&#10004; ({{$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_already_applicant_year }})</span>
            <span v-else>&#10008;</span>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  name: 'personal-data-sheet'
}
</script>
